import { useMutation } from '@tanstack/react-query';
import { ordersApi } from '@/lib/api/services/orders.api';

/** Passes an order through the expo window: Plating & QC → pickup / delivery / completed */
export function usePassOrder() {
  return useMutation({
    mutationFn: (id: number) => ordersApi.pass(id),
  });
}

/** Marks an order as handed off / fulfilled — status → COMPLETED, removed from board */
export function useCompleteOrder() {
  return useMutation({
    mutationFn: (id: number) => ordersApi.complete(id),
  });
}
